import { Page } from "components/common";
import HistoricalDataContainer from "containers/enviroment/historicalData/HistoricalData.container";
import React from "react";

const HistoricalDataPage = () => {
    return (<Page title='Dati storici'>
        <HistoricalDataContainer />
    </Page>)
}

export default HistoricalDataPage